import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import PlayerDecisionsTableDisabled from './PlayerDecisionsTableDisabled';
import Team from './Team';
import { useState } from 'react';
import { useAuth } from "../AuthProvider";
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { GAME_STATUS } from './constants';

const AdminDecisionsTable = ({ teams, decisionDefinitions, decisionValues, rounds, round, id, status, results, reloadGame }) => {
    const auth = useAuth();
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState(teams[0].name);
    const [autofillingTeam, setAutofillingTeam] = useState();
    const [error, setError] = useState();

    const autofill = (team) => {
        setAutofillingTeam(team.name);
        axios.post(`/api/games/${id}/decisions/${round}/autofill`, { team: team.name }, {
            headers: {
                Authorization: `Bearer ${auth.token}`,
            },
        })
            .then(() => {
                setError(undefined);
                setAutofillingTeam(undefined);
                reloadGame(id);
            })
            .catch(error => {
                console.log(error);
                setError(t('teams.autofill-error'));
                setAutofillingTeam(undefined);
            });
    };

    return <Tabs
        activeKey={activeTab}
        onSelect={(team) => setActiveTab(team)}
        className="mb-3">
        {
            teams.map(team =>
                <Tab key={team.name} eventKey={team.name} title={team.name}>
                    <Team team={team} />
                    {error && <Alert variant="danger" dismissible onClose={() => setError(undefined)}>{error}</Alert>}
                    {team.automaton && status === GAME_STATUS.ROUND_ACTIVE &&
                        <Button
                            variant="secondary"
                            className="mb-3"
                            disabled={autofillingTeam === team.name}
                            onClick={() => autofill(team)}
                        >
                            {t('teams.autofill')}
                        </Button>
                    }
                    <PlayerDecisionsTableDisabled
                        team={team.name}
                        decisionDefinitions={decisionDefinitions}
                        decisionValues={decisionValues}
                        rounds={rounds}
                        round={round}
                        id={id}
                        status={status}
                        results={results}
                    />
                </Tab>
            )
        }
    </Tabs>;
};

export default AdminDecisionsTable;
